import styled from 'styled-components';

import {colors} from 'theme';

export const ListRow = styled.div`
    padding: 16px 20px;
    background: ${colors.white};
    margin: 10px 0;

    &:first-of-type {
        margin-top: 0;
    }

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const RowElement = styled.div`
    margin-bottom: 10px;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const FlexRowElement = styled(RowElement)`
    display: flex;
    justify-content: space-between;
`;

export const Text = styled.div<{isGray?: boolean}>`
    flex: 1;
    color: ${(p) => (p.isGray ? colors.textSecondary : colors.textPrimary)};
    font-size: 14px;
    &:nth-of-type(2n) {
        text-align: right;
    }
`;
